/* eslint-disable new-cap */
import CalendarAvailability from './custom_hours';
import CardWrapper from '../wrapper/card';
import CustomDropdown from '../reusable/dropdown';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { udpateUserTimeZoneThunk } from '../../redux/thunks/calendar';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import WeeklyHoursComponent from './weekly_hours';
import { a11yProps, CustomTabPanel } from '../../pages/deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, SelectChangeEvent, Tab, Tabs, Typography } from '@mui/material';
import { settingAvailabilityFlag, settingSelectedTabForAvailability } from '../../redux/slices/calendar';
import { useDispatch, useSelector } from 'react-redux';

const SetAvailabilityComponent = () => {
    const { slots, timezoneDetails } = useSelector((state: RootState) => state.calendar);
    const { id } = useParams();
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);
    const dispatch = useDispatch<AppDispatch>();
    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
        dispatch(settingSelectedTabForAvailability(newValue));
    };

    useEffect(() => {
        let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
        if (!currentUser?.calendar_time_zone) {
            dispatch(udpateUserTimeZoneThunk({
                user_id,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }));
        }
    }, [currentUser?.calendar_time_zone, id, selectedCustomer?.id, currentUser?.id, dispatch]);

    const updateTimeZoneHandler = async (value: string) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            await dispatch(udpateUserTimeZoneThunk({
                user_id,
                timezone: value
            })).unwrap();
        } catch (e) {
            //
        }
    };

    return <Box>
        <CardWrapper>
            <Button variant="text" color="secondary" onClick={() => dispatch(settingAvailabilityFlag(false))}><KeyboardArrowLeft />Back to Calendar</Button>
            <Box padding="15px" minHeight="80vh" overflow="auto">
                <Tabs
                    value={slots.selectedTab}
                    onChange={handleChange}
                    aria-label="set availability"
                >
                    <Tab
                        label="Weekly hours"
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="Custom hours"
                        {...a11yProps(1)}
                    />
                </Tabs>
                <Divider />
                <Box display="flex" justifyContent="space-between" alignItems="center" my={2}>
                    <Typography variant="subtitle1" color="textSecondary">{slots.selectedTab === 0 ? 'Set available hours for whole week' : 'Set custom available days and hours'}</Typography>
                    <Box>
                        <CustomDropdown
                            value={timezoneDetails.timezone}
                            options={timezoneDetails.allTimezones.map((item: {zone: string; time: string}) => ({
                                label: `${item.zone} (${item.time})`,
                                value: item.zone
                            }))}
                            onChange={(e: SelectChangeEvent<unknown>) => updateTimeZoneHandler(e.target.value as string)}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 500,
                                        overflowY: 'auto'
                                    }
                                }
                            }}
                            sx={{ mb: 0 }}
                        />
                    </Box>
                </Box>
                <CustomTabPanel value={slots.selectedTab} index={0}>
                    <WeeklyHoursComponent />
                </CustomTabPanel>

                <CustomTabPanel value={slots.selectedTab} index={1}>
                    <CalendarAvailability />
                </CustomTabPanel>
            </Box>
        </CardWrapper>
    </Box>;
};

export default SetAvailabilityComponent;